import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CasStackRow } from 'src/compass/shared/components';
import { CasRHFRiskWithSalesManagerSelect } from 'src/compass/application/general/components/CasRiskWithSalesManagerSelect';
import { CasRHFSourceSelect } from 'src/compass/application/general/components/CasSourceSelect';

type FieldProps = {
  asofReadonly: boolean;
};

export default function SourceEmployeeAndTypeFields({ asofReadonly }: FieldProps) {
  const triggerFields = ['asOf.sourceEmployeeId', 'asOf.sourceId'];

  const { control, trigger } = useFormContext();

  const [sourceEmployeeId, sourceId] = useWatch({
    control,
    name: triggerFields,
  });

  useEffect(() => {
    if (sourceEmployeeId !== undefined && sourceId !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceEmployeeId, sourceId, trigger]);

  return (
    <CasStackRow gapSize="none">
      <CasRHFRiskWithSalesManagerSelect
        includeNoneOption
        name="asOf.sourceEmployeeId"
        label="Source Employee"
        disabled={asofReadonly}
      />
      <CasRHFSourceSelect name="asOf.sourceId" label="Type" includeNoneOption disabled={asofReadonly} />
    </CasStackRow>
  );
}
